export default __webpack_public_path__ + "static/media/reset-passwprd.af461291.png";